// JS file for FaqItem

import '@main';

u.rwdVideo('.article-content');
